import { IType } from "modules/Utilities/LeasedEquipmentConfiguration/Type/types";
import axios from "../../../utils/authAxios";
const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/LeasedEquipmentConfiguration";

export const getLeasedEquipmentTypeList = async () => {
  return axios.get(`${api_base_url}/GetType`).then((res) => {
    return res;
  });
};

export const addLeasedEquipmentType = async (newType: IType) => {
  const { data } = await axios.post(`${api_base_url}/AddType`, {
    ...newType,
  });
  return data;
};

export const deleteLeasedEquipmentType = async (ids: number[]) => {
  const { data } = await axios.delete(`${api_base_url}/DeactivateType`, {
    data: ids,
  });
  return data;
};

export const updateLeasedEquipmentType = async (
  editLeasedEquipmentType: IType
) => {
  const { data } = await axios.put(
    `${api_base_url}/EditType`,
    editLeasedEquipmentType
  );
  return data;
};
